export default __webpack_public_path__ + "static/media/message-icon.a63af2cb.svg";